import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

import AdminAuth from "../components/AuthenticationForm/AdminAuth/AdminAuth";
import VerifyContactsNotification from "../components/PersonalAccount/ProfileSettings/VerifyContactsNotification/VerifyContactsNotification";

function ProtectedRoute({ component: Component, ...restOfProps }) {
  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
  const hasNotConfirmedContact = useSelector(state => state.auth.hasNotConfirmedContact)

  const setRenderComponent = (props) => {
    if (user) {
      if (user.authorities.indexOf("ROLE_ADMIN") === -1) {
        if (!hasNotConfirmedContact) return <Component {...props} />
        else return <VerifyContactsNotification {...props} />
      } else return <AdminAuth {...props} />
    } else return <Redirect to="/login" />
  }

  return (
    <Route
      {...restOfProps}
      render={(props) => setRenderComponent(props)}
    />
  );
}

export default ProtectedRoute;
